import { AnyAction } from 'redux';
import { setRequestStatus } from 'data-layer-cr/dist/network';
import qs from 'qs';

import {
  login as authLogin,
  getLoggedRole,
  getLoggedLicense,
  getLoggedUserId,
  getLoggedUserName,
} from 'data-layer-cr/dist/authentication';

import { AsyncAppThunk, AsyncDispatch, AppThunk } from '../../ThunkTypes';
import {
  requestProfile,
  requestProfileSuccess,
  requestProfileFailure,
  setCurrentRole,
  setLastLoginErrorMessage,
  setSessionEmail,
  setCurrentLicense,
  setProfileIdUser,
  setProfileName,
} from '../slice/profileSlice';

import makeLoginErrorMessage from './makeLoginErrorMessage';

import AuthResponse from '../../../models/responseTypes/AuthResponse';
import Profile from '../../../models/Profile';

import AuthNetworkClient from '../../../services/AuthNetworkClient';
import processRequest from '../../../services/processRequest';

import { LOGIN_REQUEST } from '../requestIdentifiers';

/** Unused */
export const updateProfile =
  (profileId: string): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(requestProfile());
    try {
      const data = await processRequest<Profile>({
        method: 'GET',
        url: `security/authorization/${profileId}`,
      });
      return dispatch(requestProfileSuccess(data));
    } catch (e) {
      return dispatch(requestProfileFailure());
    }
  };

/**
 * Tries to log the user in the application
 *
 * @param username - The provided username
 * @param password - The provided password
 */
export const login =
  (username: string, password: string): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(LOGIN_REQUEST, 'requesting'));
    try {
      const result = await processRequest<AuthResponse>({
        method: 'POST',
        url: '/connect/token?authType=ASE',
        data: qs.stringify({
          grant_type: 'password',
          client_id: 'sales-web',
          client_secret: 'secret',
          username,
          password,
        }),
        client: AuthNetworkClient,
      });
      authLogin({
        token: result.access_token,
        expiration: result.expires_in,
      });
      dispatch(setCurrentRole(getLoggedRole()));
      dispatch(setCurrentLicense(getLoggedLicense()));
      dispatch(setProfileIdUser(getLoggedUserId()));
      dispatch(setProfileName(getLoggedUserName()));
      return dispatch(setRequestStatus(LOGIN_REQUEST, 'success'));
    } catch (e) {
      dispatch(setLastLoginErrorMessage(makeLoginErrorMessage(e)));
      return dispatch(setRequestStatus(LOGIN_REQUEST, 'failure'));
    }
  };

/**
 * Resets the login error messsage back to an empty value
 */
export const resetLoginErrorMessage =
  (): AppThunk =>
  (dispatch): void => {
    dispatch(setLastLoginErrorMessage(''));
  };

/**
 * Sets user data
 * @param role
 * @param email
 * @param license
 * @param userName
 * @param userId
 */
export const updateUserData =
  (
    role: string,
    email: string,
    license: string,
    userName: string,
    userId: string,
  ): AppThunk =>
  (dispatch): void => {
    dispatch(setCurrentRole(role));
    dispatch(setSessionEmail(email));
    dispatch(setCurrentLicense(license));
    dispatch(setProfileIdUser(userId));
    dispatch(setProfileName(userName));
  };
